(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/backgrounds/assets/react/triss-background/triss-background.js') >= 0) return;  svs.modules.push('/components/tur/backgrounds/assets/react/triss-background/triss-background.js');
"use strict";


const TrissBackground = () => React.createElement("div", {
  className: "backgrounds backgrounds-triss bg-triss"
});
svs.components.tur.backgrounds.TrissBackground = TrissBackground;

 })(window);